export default __webpack_public_path__ + "static/media/uimg1.edfca127.webp";